import { useId } from "react";
import { getContrastColor } from "utils/helpers";

export default function Input({
  id,
  label = "",
  labelInBorder,
  bgColor = "FFFFFF",
  disabled = false,
  ...props
}) {
  const contrastColor = getContrastColor(bgColor);
  // The visible label is the input's accessible name only through a real
  // htmlFor/id pair (WCAG 1.3.1 / 4.1.2); a caller's `id` wins, otherwise
  // useId() keeps the pair unique per instance.
  const reactId = useId();
  const inputId = id || reactId;

  return (
    <div className="relative">
      <label
        htmlFor={inputId}
        className={`font-inter  inline-block px-1 font-medium ${
          labelInBorder
            ? "uppercase tracking-wider text-[10px] -top-1.5 left-4 absolute "
            : ""
        }`}
        style={{ background: bgColor, color: contrastColor }}
      >
        &nbsp;&nbsp;{label}&nbsp;&nbsp;
      </label>
      <div>
        <input
          id={inputId}
          className="block w-full  rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  focus:ring-mb-main sm:text-sm sm:leading-6"
          style={{ background: bgColor, color: contrastColor }}
          disabled={disabled}
          {...props}
        />
      </div>
    </div>
  );
}
